export enum SnackBarMessage {
  ERROR_UPDATING_DETAILS = 'An error occurred while updating details',
  EMAIL_UPDATED = 'Email updated successfully, please log in again',
  DETAILS_UPDATED = 'Details updated successfully',
  FAILURE = 'Something went wrong, please try again',
  PREVIEW_PROFILE_PHOTO = 'An error ocurred while viewing profile photo',
  UPLOAD_IMAGE_SUCCESS = 'Image uploaded successfully',
  UPLOAD_IMAGE_FAILURE = 'Error uploading photo.',
  SUCCESS = 'Success',
  CLOSE = 'Close',
  SAVED_FILE ='File already saved',
  INVOICES_SENT = 'Invoices sent back successfully',
  NO_FILES = "NO_FILES",
  USER_DELETED= "deleted successfully",
  ERROR_DELETING_USER= 'Error deleting user. Please try again.',
  ALLOCATION_FAILED = 'Allocation failed, please try again.',
  REPORTS_FAILED = 'Fetching data failed',
  REPORT_GENERATION_FAILED = 'Failed to generate the report. Please try again.',
  NO_STUDENT_DATA='Student data is not available',
  INVALID_DEPARTMENT = "Verify the department,faculty and university then try again.",
  RSVP_SUCCESS = 'RSVP updated successfully!',
  RSVP_FAILURE = 'An error occurred while updating RSVP',
  REVERT_SUCCESS = 'Application reverted successfully',
  UNIVERSITY_ADDED = 'University added successfully',
  UPDATE_AVERAGE_SUCCESS = 'Average grade updated successfully',
  APPLICATION_SAVED_SUCCESS = 'Application saved successfully!',
  ERROR_SAVING_APPLICATION = 'Error saving application. Please try again.'
}
